/**
 * Created by zuozhuo on 2018/1/25.
 */
import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import utils from "../utils/utils";
import weixinJsSdk from "../utils/weixinJsSdk";
import { restoreAppHeight } from "../utils/appWebviewHeightFix";
import { DEFAULT_SHARE_IMAGE } from "../consts/consts";
import bridgeApis from "../utils/bridge/bridgeApis";

function createCustomRouteRender(route) {
  return function(props) {
    // 未登录 跳转到登录页
    if (route.loginRequired && !utils.isAtLoginPage() && !utils.isLogin()) {
      utils.redirectToLogin(utils.getCurrentPageUrl(), { push: false });
      return null;
      // return <Redirect push={false} to={utils.getLoginUrl()} />;
    }

    if (!utils.isAtLoginPage()) {
      // 每次路由切换, 都尝试去初始化微信jssdk,
      // 并重置分享链接为默认首页
      weixinJsSdk.setDefaultShare({
        showPopup: undefined
      });
    }

    if (utils.isFoApp()) {
      bridgeApis.setShareButtonVisibleDebounce(false);
    }

    // 恢复App高度
    restoreAppHeight();

    // 渲染原始组件
    // 支持routes=[]嵌套路由
    // pass the sub-routes down to keep nesting
    return <route.component {...props} routes={route.routes} />;
  };
}

const CustomRoute = route => {
  const { component, ...rest } = route;

  return <Route {...rest} render={createCustomRouteRender(route)} />;
};

export default CustomRoute;



// WEBPACK FOOTER //
// ./src/router/CustomRoute.js